import { Controller } from "@hotwired/stimulus"

// Operator ledger price lens. Every figure is rendered twice server-side (a
// data-base and a data-posted on the same element); flipping the lens just swaps
// which one is shown and hides/shows the cash-discount rows. No reload, no query —
// Billing::Statement already computed both denominations and both running balances.
//   Base (default): the operator's own prices; discount rows hidden.
//   Transactions:   posted/card prices; discount rows shown.
export default class extends Controller {
  static targets = ["row", "amount", "running", "balance", "balanceLabel", "tabBase", "tabTx"]

  connect() {
    this.showBase()
  }

  showBase() {
    this.#apply("base", "Current balance", true)
  }

  showTransactions() {
    this.#apply("posted", "Balance if paid by card", false)
  }

  #apply(key, label, baseMode) {
    this.balanceTarget.textContent = this.balanceTarget.dataset[key]
    this.balanceLabelTarget.textContent = label
    this.amountTargets.forEach((el) => { el.textContent = el.dataset[key] })
    this.runningTargets.forEach((el) => { el.textContent = el.dataset[key] })
    // A row flagged base-only (the dual-pricing cash-discount credit) is hidden in
    // the Base lens, where it would be meaningless noise.
    this.rowTargets.forEach((row) => {
      row.classList.toggle("hidden", baseMode && row.dataset.baseOnly === "1")
    })
    this.#lightTab(this.tabBaseTarget, baseMode)
    this.#lightTab(this.tabTxTarget, !baseMode)
  }

  #lightTab(tab, on) {
    tab.classList.toggle("bg-white", on)
    tab.classList.toggle("text-primary-700", on)
    tab.classList.toggle("shadow-sm", on)
    tab.classList.toggle("text-secondary-600", !on)
  }
}
